module.exports = __webpack_public_path__ + "static/media/icon-profile-user-empty.86b88332.svg";